// 가맹점주 챗봇 흐름 문구(ko·zh, 시안 v1). 없는 키는 기존 사전(i18n/messages)에서 찾는다.
import { useCallback } from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { messages } from "../../i18n/messages";

export const CHAT_TEXT = {
    ko: {
        "cf.store.title": "가맹점 확인",
        "cf.store.desc": "등록된 가맹점 정보를 확인했습니다.",
        "cf.store.hint": "위 내용이 맞으면 「예」를 눌러주세요. 「아니오」를 누르면 처음 화면으로 돌아갑니다.",
        "cf.store.name": "상호명",
        "cf.store.owner": "대표자",
        "cf.store.addr": "주소",
        "cf.yes": "예",
        "cf.no": "아니오",
        "cf.ask.menu": "수정·추가할 메뉴 내용을 적어주세요. 사진은 최대 3장까지 올릴 수 있어요.",
        "cf.ask.printer": "어떤 증상인지 적어주세요. (예: 소리만 나고 출력 안 됨) 사진을 함께 올리면 더 빨라요.",
        "cf.ask.pay": "단말기 화면에 뜨는 오류 메시지나 증상을 적어주세요.",
        "cf.ask.other": "어떤 내용인지 적어주세요. 사진을 함께 올리면 더 빨라요.",
        "cf.ask.period": "조회 기간을 골라주세요.",
        "cf.ask.receive": "자료를 받으실 이메일 또는 팩스 번호를 입력해 주세요.",
        "cf.bad.receive": "이메일 또는 팩스 번호 형식이 아닌 것 같아요. 다시 입력해 주세요. (예: name@example.com)",
        "cf.goInq": "내 문의 현황 열기",
        "cf.done.paper": "용지신청이 완료되었습니다. 오후 4시 이전 접수시 당일출고 오후 4시 이후 접수건은 다음날에 출고됩니다.",
        "cf.done.sales": "접수가 완료되었습니다. 카드사·국세청 집계와 다를 수 있습니다.",
        "cf.done.menu": "접수해주신 내용을 확인 후 작업 예정이며, 완료 시 연락 드리겠습니다.",
        "cf.done.printer": "접수해주신 내용을 확인 후 담당자가 연락 드리겠습니다.",
        "cf.done.reask": "접수했어요. 이전 문의(No.{id}) 이력과 함께 담당자에게 전달돼요.",
        "cf.done.hint": "처리가 끝나면 내 문의 현황에서 결과를 볼 수 있어요.",
        "cf.merged": "이미 접수된 같은 문의가 있어 그 문의(No.{id})에 내용을 덧붙였어요.",
        "cf.fail": "접수하지 못했어요. 잠시 뒤 다시 시도해 주세요.",
        "cf.fail.photo": "사진은 이미지 파일로 3장까지 올릴 수 있어요.",
        "cf.fail.notCompleted": "아직 진행 중인 문의예요. 내 문의 현황에서 내용을 덧붙여 주세요.",
        "cf.fail.notFound": "이전 문의를 찾을 수 없어요.",
        "cf.reask.user": "{sub} 문제가 다시 생겼어요 (이전 문의 No.{id})",
        "cf.reask.bot": "이전 처리 내용을 확인했어요: “{result}” 같은 증상인지, 달라진 점이 있는지 적어주시면 담당자에게 이전 이력과 함께 접수할게요.",
        "cf.reask.botNoResult": "같은 증상인지, 달라진 점이 있는지 적어주시면 담당자에게 이전 이력과 함께 접수할게요.",
        "cf.resumed": "이전 대화를 불러왔어요. 이어서 질문하세요.",
        "cf.resumeGone": "지난 대화를 찾을 수 없어 새 대화로 시작해요.",
        "cf.attach": "사진 첨부 ({n}/3)",
        "cf.notice.prompt": "최신 공지예요. 제목을 누르면 내용을 볼 수 있어요.",
        "cf.empty.notice": "게시 중인 공지가 없습니다.",
        "cf.period.h1": "상반기",
        "cf.period.h2": "하반기",
        "cf.period.all": "전체",
        "cf.period.custom": "직접입력",
        "cf.period.apply": "선택 완료",
    },
    zh: {
        "cf.store.title": "加盟店确认",
        "cf.store.desc": "已确认登记的加盟店信息。",
        "cf.store.hint": "信息正确请点“是”。点“否”将返回首页。",
        "cf.store.name": "店名",
        "cf.store.owner": "负责人",
        "cf.store.addr": "地址",
        "cf.yes": "是",
        "cf.no": "否",
        "cf.ask.menu": "请填写需要修改或添加的菜单内容，最多可上传3张照片。",
        "cf.ask.printer": "请描述故障症状（例：只有声音但无法打印），附上照片处理更快。",
        "cf.ask.pay": "请填写刷卡机屏幕上显示的错误信息或症状。",
        "cf.ask.other": "请填写具体内容。附上照片会更快处理。",
        "cf.ask.period": "请选择查询期间。",
        "cf.ask.receive": "请输入接收资料的邮箱或传真号码。",
        "cf.bad.receive": "邮箱或传真号码格式似乎不正确，请重新输入。（例：name@example.com）",
        "cf.goInq": "打开我的咨询",
        "cf.done.paper": "用纸申请已完成。下午4点前提交当天发货，下午4点后提交次日发货。",
        "cf.done.sales": "已受理。可能与信用卡公司或国税厅的统计有所不同。",
        "cf.done.menu": "确认您提交的内容后将进行处理，完成后会联系您。",
        "cf.done.printer": "确认您提交的内容后，负责人会与您联系。",
        "cf.done.reask": "已受理，将与原咨询 No.{id} 一起转达给负责人。",
        "cf.done.hint": "处理完成后可在“我的咨询”中查看结果。",
        "cf.merged": "已有相同的咨询，已将内容补充到该咨询（No.{id}）。",
        "cf.fail": "提交失败，请稍后再试。",
        "cf.fail.photo": "最多可上传3张图片文件。",
        "cf.fail.notCompleted": "该咨询仍在处理中，请在“我的咨询”中补充内容。",
        "cf.fail.notFound": "找不到原咨询。",
        "cf.reask.user": "{sub}问题再次出现（原咨询 No.{id}）",
        "cf.reask.bot": "已确认之前的处理内容：“{result}”。请说明是否为相同症状或有何变化，我们将连同之前的记录一起提交给负责人。",
        "cf.reask.botNoResult": "请说明是否为相同症状或有何变化，我们将连同之前的记录一起提交给负责人。",
        "cf.resumed": "已加载之前的对话，请继续提问。",
        "cf.resumeGone": "找不到之前的对话，将开始新的对话。",
        "cf.attach": "附加照片（{n}/3）",
        "cf.notice.prompt": "这是最新公告，点击标题查看内容。",
        "cf.empty.notice": "暂无公告。",
        "cf.period.h1": "上半年",
        "cf.period.h2": "下半年",
        "cf.period.all": "全年",
        "cf.period.custom": "自定义",
        "cf.period.apply": "确认选择",
    },
};

const fill = (s, vars) => s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] ?? m));

// 화면 언어 문구 — chat 문구에 없으면 기존 사전(messages)
export function useChatText() {
    const { lang } = useLanguage();
    return useCallback((key, vars = {}) => {
        const s = (CHAT_TEXT[lang] || CHAT_TEXT.ko)[key] ?? CHAT_TEXT.ko[key] ?? messages[lang]?.[key] ?? messages.ko[key] ?? key;
        return fill(s, vars);
    }, [lang]);
}

// 서버에 보내는 접수 내용은 늘 한국어(관리자용)
export const koText = (key, vars = {}) => fill(CHAT_TEXT.ko[key] ?? messages.ko[key] ?? key, vars);
